// @ts-nocheck
import React from 'react';
import { pddGroupApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await pddGroupApi.fetch({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={pddGroupApi.get} notFoundText="Темы ПДД не найдены" placeholder="Выберите тему ПДД" renderOption={(pddGroup, Option) => <Option key={pddGroup.id} value={pddGroup.id} group={pddGroup}>
        {pddGroup.name}
      </Option>} {...selectProps} />;
